import React from "react";
import styles from "./Input.module.css";

function Input({
  label,
  type = "text",
  name,
  value,
  onChange,
  options = [],
  required = false,
  rows = 3, // Textarea rows 속성 기본값
}) {
  return (
    <div className={styles.inputGroup}>
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>
      {type === "select" ? (
        
        <select
          id={name}
          name={name}
          value={value || ""} // value가 undefined일 경우 빈 문자열로 설정
          onChange={onChange}
          className={styles.select}
          required={required}
        >
          <option value="">Select {label}</option>
          {options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))}
        </select>
      ) : type === "textarea" ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          className={styles.textarea}
          rows={rows} // rows 속성 추가
          required={required}
        />
      ) : (
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          className={styles.input}
          required={required}
        />
      )}
    </div>
  );
}

export default Input;